/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';
import './paymentOptions.scss';

const trackPaymentOptionsScript = (elementId, paymentOptionLabel) => {
  return `
    <script>
      document.getElementById('${elementId}').addEventListener("click", function(){
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'footer_payment_logo_click',
            eventCategory: 'Footer',
            eventAction: 'Payment Logo Click',
            eventLabel: '${paymentOptionLabel}',
          });
        }
      });
    </script>
  `;
};

const PaymentOptions = ({ title, options, imageDomain }) => {
  if (!options || !imageDomain) {
    return null;
  }

  return (
    <div className="footer-payment-options">
      {title && <h2 className="footer-payment-options__title">{title}</h2>}
      <ul className="footer-payment-options-list">
        {options.map((paymentOption, index) => {
          if (!paymentOption.image?.media?.cloudinaryUriTemplate) {
            return null;
          }

          const { media, title: imageTitle, alt } = paymentOption.image;
          const { target = '_blank', url = '' } =
            paymentOption?.readMoreLink?.href || {};

          const RenderType = url ? 'a' : 'div';
          const potentialUrlProps = url
            ? {
                href: url,
                target,
                id: imageTitle,
                className: 'footer-payment-options-list__link',
              }
            : {};

          return (
            <RenderType {...potentialUrlProps} key={`${imageTitle}-${index}`}>
              <li id={title} className="footer-payment-options-list__item">
                <CloudinaryPicture
                  className="footer-payment-options-list__item-image"
                  img={media}
                  alt={alt}
                  sizes={[
                    {
                      width: 58,
                      height: 32,
                    },
                  ]}
                  formats={['svg']}
                  lazy
                />
              </li>
              <div
                dangerouslySetInnerHTML={{
                  __html: trackPaymentOptionsScript(title, title),
                }}
              />
            </RenderType>
          );
        })}
      </ul>
    </div>
  );
};

PaymentOptions.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({}),
      readMoreLink: PropTypes.shape({}),
    }),
  ).isRequired,
  imageDomain: PropTypes.string.isRequired,
};

PaymentOptions.defaultProps = {
  className: null,
  title: null,
};

export default PaymentOptions;
